import React from "react";

export type Claim = {
	type: string;
	value: string;
};

export type ClientConfiguration = {
	environment: string;
	file_management_storage_account: string;
};

type AuthContextType = {
	loggedIn: boolean;
	loading: boolean;
	claims?: Claim[];
	currentUser?: CurrentUserDTO;
	clientConfiguration?: ClientConfiguration;
};

const initialState: AuthContextType = {
	loggedIn: false,
	loading: true,
};

const AuthContext = React.createContext(initialState);

export default AuthContext;
